/** Whitelisted reaction emojis. Anything else is rejected by the server. */
export const REACTION_EMOJIS = ['👋', '🤝', '🎉', '🤔', '😅', '🔥', '☠️', '👑'];
//# sourceMappingURL=events.js.map